import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MSRemoteLoggerCategory } from '../adapters/remote-logger/utils/remote-logger.utils';
import { CONSTANTS } from '../services/config.service';
import { LoggerService } from '../services/logger.service';
import { NavigationService } from '../services/navigation/navigation.service';
import { RegistrationService } from '../services/registration/registration.service';
import { UrlService } from '../services/url.service';

@Injectable({
  providedIn: 'root'
})
export class RosterGuard implements CanActivate {
  navigationTrigger = '';

  constructor(
    private logger: LoggerService,
    private nav: NavigationService,
    private registration: RegistrationService,
    private url: UrlService
  ) {
    this.url.navigationTrigger$.subscribe((navigationTrigger: string) => {
      this.navigationTrigger = navigationTrigger;
    });
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = next.url[0].path;

    if (this.navigationTrigger === 'popstate') {
      return false;
    }

    this.logger.log('In roster guard', MSRemoteLoggerCategory.INIT);
    this.logger.log('Registration initialized:', MSRemoteLoggerCategory.INIT, CONSTANTS.registrationInitialized);

    if (CONSTANTS.appInitialized) {
      this.logger.log('App is initialized. Going to:', MSRemoteLoggerCategory.INIT, url);
      return true;
    } else {
      this.logger.log('App is NOT initialized. Running registration.initialize, then going to:', MSRemoteLoggerCategory.INIT, url);
      return this.registration.initialize().then((target) => {
        this.logger.log('Returned from registration initialize. Got target:', MSRemoteLoggerCategory.INIT, target);
        if (target[0] === '/' + url) {
          return true;
        } else {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          this.nav.nav(target);
          return false;
        }
      });
    }
  }
}
